import React from 'react'
import { Row, Col, FormGroup, Label, Input } from 'twyne-new.ui';

const TiburonForm = ({data, onChange, disabled}) => {
  return (
    <Row>
      <Col size="6">
        <FormGroup>
          <Label>Placement ID</Label>
          <Input type="text" value={data.placementid || ''}
            onChange={(e) => onChange('placementid', e.target.value)} disabled={disabled}
          />
        </FormGroup>
      </Col>
      <Col size="6">
        <FormGroup>
          <Label>Publisher ID</Label>
          <Input type="text" value={data.pubid || ''}
            onChange={(e) => onChange('pubid', e.target.value)} disabled={disabled}
          />
        </FormGroup>
      </Col>
    </Row>
  );
}

export default TiburonForm;